"use client";

import { useEffect } from "react";
import { initializeBrowserConsoleGate } from "./browser-console-gate";

/**
 * Runs browser console gate once at client bootstrap.
 */
export function BrowserConsoleGate() {
  useEffect(() => {
    initializeBrowserConsoleGate();
  }, []);
  return null;
}
